export const SET_SITEFLOW_PRODUCT = (state, product) => {
	state.siteflowProduct = product;
};

export const REMOVE_SITEFLOW_PRODUCT = state => {
	state.siteflowProduct = null;
};
